import "hammerjs";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import Amplify from "aws-amplify";
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
Amplify.configure({
    Auth: {
        region: environment.region,
        userPoolId: environment.userPoolId,
        userPoolWebClientId: environment.userPoolWebClientId,
    },
});
const init = () => {
    __NgCli_bootstrap_2.platformBrowser()
        .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory).then(() => {
        window.Android.showLoader(false);
    })
        .catch((err) => console.error(err));
};
const ɵ0 = init;
if (window.Android) {
    // opening via Android
    const url_string = window.location.href;
    const isWebviewJourney = new URL(url_string).searchParams.get('campaign') === 'app_paylater' ||
        new URL(url_string).searchParams.get('campaign') === 'app_termloans';
    if (!isWebviewJourney) {
        localStorage.clear();
        init();
    }
}
else {
    init();
}
function setAccessToken(accessToken) {
    if (accessToken) {
        window.localStorage.clear();
        window.localStorage.setItem("X-AUTH-TOKEN", accessToken);
        if (new URL(window.location.href).searchParams.get('campaign') === 'app_paylater') {
            window.localStorage.setItem('isPayLater', 'true');
        }
        else if (new URL(window.location.href).searchParams.get('campaign') === 'app_termloans') {
            window.localStorage.setItem('isTermLoans', 'true');
        }
        init();
    }
    else {
        init();
    }
}
window.setAccessToken = setAccessToken;
export { ɵ0 };
